<template>
    <Modal :show="show" @close="close()">

        <ModalSuccess v-if="success" :title="successTitle" :bodyText="successBody" buttonText="Close window"
                      @close="close()"/>

        <template v-if="step == 'REDEEM_TYPE'">

            <div class="modal-body">

                <div class="modal-header text-center">

                    <!--<h2 class="modal-title">Redeem a kit</h2>-->

                    <p class="w-100 titleText">Please select one of the following options to proceed</p>
                </div>

                <div class="modal-footer">
                    <div class="row mb-4">
                        <div class="col-sm-12 mb-sm-1" :class="optionSpacing">
                            <a class="btn btn-option w-100 h-100" :class="{ 'active' : option === 'REDEEM_SEND'}"
                               href="#" @click.prevent="setOption('REDEEM_SEND')" >

                                <span class="dot"><i class="fa fa-check" aria-hidden="true"></i></span>

                                <div>
                                     <img class="optImg" src="static/send-now-icon.svg">
                                </div>
                                <div>
                                    Send this kit to me now
                                </div>
                            </a>
                        </div>
                        <div class=" col-sm-12 mb-sm-1" :class="optionSpacing">
                            <a class="btn btn-option w-100 h-100" :class="{ 'active' : option === 'REDEEM_SEND_LATER'}"
                               href="#" @click.prevent="setOption('REDEEM_SEND_LATER')" >

                                <span class="dot"><i class="fa fa-check" aria-hidden="true"></i></span>

                                <div>
                                    <img class="optImg" src="static/send-later-icon.svg">
                                </div>
                                <div>
                                    Send this kit to me later
                                </div>
                            </a>
                        </div>
                        <div class="col-md-3 col-sm-12 mb-sm-1" v-if="showChildOption">
                            <a class="btn btn-option w-100 h-100" :class="{ 'active' : option === 'REDEEM_CHILD'}"
                               href="#" @click.prevent="setOption('REDEEM_CHILD')" >

                                <span class="dot"><i class="fa fa-check" aria-hidden="true"></i></span>

                                <div>
                                    <img class="optImg" src="static/send-tokid-icon.svg">
                                </div>
                                <div>
                                    This kit is for my child/dependant
                                </div>
                            </a>
                        </div>
                        <div class=" col-sm-12 mb-sm-1"  :class="optionSpacing">
                            <a class="btn btn-option w-100 h-100" :class="{ 'active' : option === 'REDEEM_GIVE'}"
                               href="#" @click.prevent="setOption('REDEEM_GIVE')" >

                                <span class="dot"><i class="fa fa-check" aria-hidden="true"></i></span>

                                <div>
                                <img class="optImg" src="static/send-to_someone.svg">
                                </div>
                                <div>
                                    Give this kit to someone else
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <a class="btn btn-primary" href="#" @click.prevent="setTabFromOption">Proceed</a>
                        </div>
                    </div>

                </div>

            </div>

        </template>
        <template v-if="step == 'REDEEM_CODE' || step == 'REDEEM_CODE_WITH_ADDRESS'">
            <div class="modal-body" v-if="!success">

                <div class="modal-header">
                    <h2 class="modal-title">Send this kit to me now</h2>
                </div>

                <div class="modal-body">
                    <p class="text-center">Sending this kit will result in immediate dispatch to the address below.</p>
                    <ModalAddress ref="address" v-model.sync="editedUser" />
                </div>

                <!--<transition name="slide-fade">-->
                    <!--<div v-if="error" class="alert alert-danger" role="alert">-->
                        <!--Voucher code not valid for redemption: {{ voucher }}-->
                    <!--</div>-->
                <!--</transition>-->

                <!--<div class="row">-->
                    <!--<div class="col-12">-->
                        <!--<label for="voucher" class="h6">Enter your voucher code</label>-->
                        <!--<p class="voucherSubtitle">If you have purchased or been given a kit, you will have been supplied a voucher code in an email.</p>-->
                        <!--<input v-model="voucher" id="voucher" type="text" class="share-voucher"-->
                               <!--placeholder="Voucher code"/>-->
                    <!--</div>-->
                <!--</div>-->

                <div class="row text-center mt-3">
                    <div class="col-12">
                        <a class="btn btn-primary" href="#" v-on:click.prevent="activateKit" :class="errors.items && errors.items.length ? 'disabled':''"
                           :disabled="errors.any() || !canSubmit">Proceed</a>
                    </div>
                </div>

                <div class="row text-center mb-3 mt-2">
                    <div class="col-12">
                        <!--<button class="btn plain" @click="setTab('REDEEM_TYPE')"><em>Go back</em></button>-->
                    </div>
                </div>


            </div>
        </template>
        <template v-if="step == 'REDEEM_CONSENT'">

            <div class="modal-body">
                <h2 class="modal-title text-left w-100">Reminder</h2>

                <p>For privacy reasons, each individual needs to have their own Microba account. A unique email address is required for each Microba account. We do not allow multiple users under a single Microba account in order to avoid incorrect assignment of results to an individual. If you are a parent/guardian and have already used this account for one child or other dependant, you cannot use this account for another individual.</p>
                <p>If you want to redeem this kit for a new minor or a dependant, you need to log out and create a new account for that individual. When you create a new account, you will need to select the parent/guardian or minor account type. </p>

                <div class="row text-center mt-5">
                    <div class="col-12">
                        <a class="btn btn-primary" href="#" v-on:click.prevent="onRedeem"
                           :disabled="errors.any() || !canSubmit">Proceed</a>
                    </div>
                </div>

                <div class="row text-center mb-3 mt-2">
                    <div class="col-12">
                        <!--<button class="btn plain" @click="setTab('REDEEM_TYPE')"><em>Go back</em></button>-->
                    </div>
                </div>
            </div>
        </template>
        <template v-if="step == 'REDEEM_ADDRESS'">


            <div class="modal-main ">
                <div class="modal-header">

                    <h2 class="modal-title">Confirm shipping and send kit</h2>
                    <p class="text-center w-100">The details must reflect the individual who is using this account to undertake their Microba tests.</p>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <ModalAddress ref="address" v-model.sync="editedUser" :hideNameChange="true" />
                </div>
            </div>
            <div class="row w-100">
                <div class="col-6 text-right">
                    <a class="btn btn-primary" href="#" v-on:click.prevent="sendNow"
                       :disabled="errors.any() || !canSubmit">Send now</a>
                </div>
                <div class="col-6 text-left">
                    <a class="btn btn-outline-primary" href="#" v-on:click.prevent="sendLater"
                       :disabled="errors.any() || !canSubmit">Send later</a>
                </div>
            </div>

            <div class="row w-100 text-center mt-3">
                <div class="col-12">
                    <!--<button class="btn plain" @click="setTab('REDEEM_TYPE')"><em>Go back</em></button>-->
                </div>
            </div>

        </template>
        <template v-if="step == 'REDEEM_REJECT'">
            <div  class="modal-main ">
                <div class="modal-header pl-md-5 pr-md-5">
                    <h2 class="modal-title text-left mb-3 text-center">Parent/Guardian account required</h2>
                    <p class="text-center w-100">For privacy reasons, all individuals using Microba’s services are required to have their own Microba account with a unique email address. This includes minors and other dependants.</p>
                    <p class="text-center w-100">To setup a Parent/Guardian account to manage kits for you child or dependant, simply <a href="#" @click.prevent="logoutRegister">logout and create another account</a>. You can send this kit to the email address associated with your Parent/Guardian account.</p>
                </div>


                <div class="row text-center mt-3">
                    <div class="col-12">
                        <a class="btn btn-primary" href="#" v-on:click.prevent="openGive" >Proceed</a>
                    </div>
                </div>

                <div class="row text-center mb-3 mt-2">
                    <div class="col-12">
                        <!--<button class="btn plain" @click="setTab('REDEEM_TYPE')"><em>Go back</em></button>-->
                    </div>
                </div>
            </div>

        </template>

        <ModalSendAKit :kitID="getKitId" :show="showSendModal" :giveChild="giveToChild" :voucherCode="voucher" @close="showSendModal = false" />
        <ModalOrder
                :show="showReplacementModal"
                :product="replacementKitProduct"
                :showIntro="false"
                heading=""

                title="Confirm your details"
                copy="Please confirm your details below"
                @close="showReplacementModal = false"
        />
    </Modal>
</template>

<script>
  import Modal from '@/components/models/Modal'
  import ModalSuccess from '@/components/models/components/ModalSuccess'
  import ModalAddress from '@/components/models/components/ModalAddress'
  import ModalSendAKit from '@/components/models/ModalSendAKit'
  import ModalOrder from '@/components/models/ModalOrder'
  import UserMixins from '@/mixins/userProfile'

  export default {
    name: 'ModalActivate',
    props: ['kitID', 'activateModal', 'slide'],
    mixins: [UserMixins],
    extends: Modal,
    components: {
      Modal,
      ModalAddress,
      ModalSuccess,
      ModalSendAKit,
      ModalOrder
    },
    mounted: function () {
      this.editedUser = this.user
    },
    data: function () {
      return {
        isEditing: false,
        voucher: '',
        selectedKit: null,
        step: 'REDEEM_TYPE',
        option: null,
        loading: false,
        success: false,
        error: null,
        successLater: false,
        showSendModal: false,
        showReplacementModal: false,
        radioButtonValue: null,
        replacementKitProduct: {
          amount: Number(process.env.PRICE_NEW_KIT) || 419.00,
          label: '1 Microba insight kit',
          orderType: 'NEW'
        },
        editedUser: {
          firstName: '',
          lastName: '',
          addressLine1: '',
          addressLine2: '',
          suburb: '',
          postcode: ''
        },
        activate: true
      }
    },
    computed: {
      giveToChild () {
        return this.option === 'REDEEM_CHILD'
      },
      successTitle () {
        if (!this.successLater) {
          return 'Great news, your kit is on its way!'
        } else {
          return 'Your Kit is Available'
        }
      },
      successBody () {
        if (!this.successLater) {
          return ''
        } else {
          return 'Click "Select option" again when you are ready to send this kit.'
        }
      },
      optionSpacing () {
        if (this.showChildOption) {
          return 'col-md-3'
        }
        return 'col-md-4'
      },
      showChildOption () {
        return !this.user.underAge && !this.user.guardian
      },
      getKitId () {
        return this.kitID
      },
      user: function () {
        return this.$store.state.GET_USER_RESPONSE || false
      },
      canSubmit: function () {
        return this.isValidAddress(this.editedUser) && this.voucher !== ''
      },
      successMessage () {
        if (!this.activate) {
          return 'Your kit will be sent in the next round of kit dispatches'
        }
        return 'When you\'re ready, you can choose to activate this kit in My Journey.'
      }
    },
    methods: {
      setOption (option) {
        this.option = option
//        this.step = step
      },
      setTab (type) {
        this.step = type
      },
      setTabFromOption () {
        if (this.option === 'REDEEM_SEND') {
          this.setTab('REDEEM_CODE_WITH_ADDRESS')
        } else if (this.option === 'REDEEM_SEND_LATER') {
          this.step = ''
          this.option = null
          this.exitSuccess()
        } else if (this.option === 'REDEEM_CHILD') {
          this.setTab('REDEEM_REJECT')
        } else if (this.option === 'REDEEM_GIVE') {
          this.openGive()
        }
      },
      onShow: function () {
        this.selectedKit = null
        if (this.slide && this.slide.length > 1) {
          this.step = this.slide
        } else {
          this.step = 'REDEEM_TYPE'
        }

        this.option = null
        this.voucher = ''
        this.loading = false
        this.success = false
        this.error = null
        this.showSendModal = false
        this.editedUser = Object.assign({}, this.user)
      },
      checkVoucher (type) {
//
//
//          if (type === 'GIVE') {
//            self.openGive()
//          } else if (type === 'SEND_TO_ME') {
//            self.exeRedeem(self.selectedKit.kitId, true)
//          } else if (type === 'SEND_LATER') {
//            self.exeRedeem(self.selectedKit.kitId, false)
//          } else if (type === 'REDEEM_CONSENT') {
//            self.setTab('REDEEM_CONSENT')
//          }
//
      },
      onRedeem: function () {
        // Check code is valid
        if (this.option === 'REDEEM_SEND_LATER') {
          this.checkVoucher('SEND_LATER')
        } else if (this.option === 'REDEEM_CHILD') {
          if (this.step === 'REDEEM_CONSENT') {
            this.setTab('REDEEM_ADDRESS')
          } else {
            this.checkVoucher('REDEEM_CONSENT')
          }
        }
      },
      openGive () {
        this.showSendModal = true
      },
      openBuy () {
        this.showReplacementModal = true
      },
      sendNow () {
        this.exeRedeem(this.selectedKit.kitId, true)
        this.setTab('')
      },
      sendLater () {
        this.exeRedeem(this.selectedKit.kitId, false)
        this.setTab('')
      },
      exitSuccess () {
        this.$store.dispatch('getUserKits')
        this.$store.dispatch('getSentKits')
        this.loading = false
        this.success = true
        this.successLater = true
        this.$router.push({path: 'kits'})
      },
      activateKit () {
        this.successLater = false

        const payload = {
          kitId: this.kitID,
          firstName: this.editedUser.firstName,
          lastName: this.editedUser.lastName,
          addressLine1: this.editedUser.addressLine1,
          addressLine2: this.editedUser.addressLine2,
          suburb: this.editedUser.suburb,
          state: this.editedUser.state,
          postcode: this.editedUser.postcode
        }
        this.loading = true
        this.$store.dispatch('activateKit', payload).then(success => {
          this.$store.dispatch('getUserKits')
          this.$store.dispatch('getSentKits')
          this.success = true
          this.loading = false
        }).catch(error => {
          console.log(error)
          // Refresh regardless
          this.$store.dispatch('getUserKits')
          this.$store.dispatch('getSentKits')
        })
      },
      logout: function () {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/login')
        })
      },
      logoutRegister () {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/register')
        })
      }
    },
    watch: {
      showSendModal () {
        if (this.showSendModal === false) {
          this.close()
        }
      },
      showReplacementModal () {
        if (this.showReplacementModal === false) {
          this.close()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .form {
        padding-top: 1rem;
        margin-top: 1rem;
    }

    .titleText {
        font-size:22px;
    }

    img {
        margin: 0px auto;
    }

    .btn-option {
        border: 1px solid #eaeaea;
        border-radius: 10px;
        white-space: normal;
        text-align: center;
        padding: 13px;
        font-size: 14px;
    }

    a.btn-option:hover {
        border: 2px solid #f08c35;
        box-shadow: 0px 0px 4px #ccc;
    }

    a.btn-option.active {
        color: #01b299;
        border: 2px solid #01b299;
        box-shadow: 0px 0px 4px #ccc;
    }

    a.btn-option.active .dot{
        display: inline-block;
    }

    .dot {
        position: absolute;
        top: -10px;
        right: 27px;
        display: none;
        height: 25px;
        width: 25px;
        background-color: #01b299;
        color: #fff;
        border-radius: 50%;
        padding-left: 1px;
        padding-top: 4px;
    }

    .radioHint{
        margin-left:30px;
        font-size:14px;
    }
    .flex-center-vertically {
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 400px;
    }

    .form-checkbox {
        label {
            color: #ff8708 !important;
        }
    }

    label {
        color: #ff8708 !important;
    }

    label.h6{
        color: #000 !important;
        margin-bottom:5px;
    }

    .optImg{
        max-width:100px;
    }

    .voucherSubtitle{
        font-size: 14px;
    }

    .modal-address {
        padding-top: 2rem;
        padding-bottom: 1.5rem;
    }

    .modal-header {
        img {
            margin-bottom: 2rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/models/ModalActivate.vue